import { NavigationCardsModal } from './NavigationCardsModal';

export default NavigationCardsModal;
